import Emitter from '@utils/eventEmitter';

export const onDownloadFile = ({url, fileName}) => {
	const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName); //or any
  // other extension
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    link.parentNode.removeChild(link);
  });

  Emitter.emit('SHOW_MESSAGE', {
    text: `다운로드가 완료 되었습니다.`,
  });
};